// React component for the tabs on the shared link page

import React from 'react';
import TwTab from '../../../components/TwTab/TwTab';
import { Order, SharedTokenResponse } from '../../../redux/api/orders/orders.model';
import TwTabs from '../../../components/TwTabs/TwTabs';
import { useAppSelector } from '../../../redux/hooks';
import { Trip } from '../../../redux/api/trips/trips.model';

// Props for the Tabs component
interface TabsProps {
  sharedTokenResponse: SharedTokenResponse | null;
  currentTab: number;
  setCurrentTab: (value: number) => void;
}

const getDriverLinkTabs = (
  sharedTokenResponse: SharedTokenResponse | null,
  isLtlEnabled: boolean
): JSX.Element[] => {
  const formatTabsTitle = (): string => {
    let label = '';
    if (isLtlEnabled) {
      label = `Trip #${sharedTokenResponse?.trip?.readable_id}`;
    } else {
      const orders = sharedTokenResponse?.trip?.orders;
      if (orders && orders.length > 0) {
        const trip_sort_order = sharedTokenResponse?.trip?.sort_order || 0;
        label = `Trip #${orders[0]?.readable_id || ''}-${trip_sort_order + 1}`;
      }
    }
    return label;
  };
  const items: JSX.Element[] = [<TwTab key={0} label={formatTabsTitle()} />];

  sharedTokenResponse?.trip?.orders?.map((order, index) => {
    items.push(<TwTab key={index + 1} label={`Order #${order.readable_id}`} />);
  });

  return items;
};

const getPublicLinkTabs = (
  sharedTokenResponse: SharedTokenResponse | null,
  isLtlEnabled: boolean
): JSX.Element[] => {
  const canCustomerSeeTrips =
    sharedTokenResponse?.tenant?.tenantSettings?.['customer-access-trips'];

  const order = sharedTokenResponse?.order;

  const items: JSX.Element[] = [<TwTab key={0} label="Order details" />];

  const formatTabsTitle = (order: Order, trip: Trip): string => {
    let label = '';
    if (isLtlEnabled) {
      label = `Trip #${trip.readable_id}`;
    } else {
      label = `Trip #${order.readable_id}-${trip.sort_order + 1}`;
    }
    return label;
  };

  canCustomerSeeTrips &&
    order?.trips?.map((trip, index) => {
      items.push(<TwTab key={index + 1} label={formatTabsTitle(order, trip)} />);
    });

  return items;
};

const SharedLinkTabs: React.FC<TabsProps> = ({
  sharedTokenResponse,
  currentTab,
  setCurrentTab
}) => {
  const isLtlEnabled = useAppSelector((state) => state.user.isLtlEnabled);
  return (
    <TwTabs
      variant="scrollable"
      value={currentTab}
      onChange={(_, value): void => setCurrentTab && setCurrentTab(value)}
      aria-label="TwTabs"
      role="TwTabs"
      scrollButtons
      sx={{
        width: '100%',
        alignSelf: 'baseline',
        paddingLeft: '20px',

        '& .MuiTabs-scroller': {
          height: '50px'
        },
        '& .MuiTabs-scroller .MuiTabs-indicator': {
          backgroundColor: '#3A4DE9',
          height: '1px',
          border: '1.3px solid #3A4DE9',
          borderRadius: '10px 10px 0 0',
          width: '36px'
        },
        '& .Mui-selected': {
          textTransform: 'none',
          color: '#1d212c'
        }
      }}
    >
      {sharedTokenResponse?.driver
        ? getDriverLinkTabs(sharedTokenResponse, isLtlEnabled)
        : getPublicLinkTabs(sharedTokenResponse, isLtlEnabled)}
    </TwTabs>
  );
};

export default SharedLinkTabs;
